// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import {   
    Flex
} from '@mantine/core'

// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    DeletePlaceButton 
} from '../../../components/buttons/delete/DeletePlaceButton'

import { 
    CancelButton 
} from '../../../components/buttons/form/CancelButton'


interface DeletePlaceBarProps {
    editPlaceId: number,
}


/**
 * This menu bar renders the save, save&close and cancel button.
 */
export const DeletePlaceBar = (props: DeletePlaceBarProps) => {   
    return (
        <Flex 
            direction={{ base: 'column', sm: 'row' }}
            gap={{ base: 'sm', sm: 'lg' }}
            justify={{ sm: 'flex-end' }}
        >
            <DeletePlaceButton
                editPlaceId = {props.editPlaceId}
            />
            <CancelButton/>
        </Flex>   
    )
} 